<section class="aliyot-page w-full p-2">
  <div class="noPrint w-full max-w-3xl mx-auto px-4 py-5 flex flex-col sm:flex-row gap-3 items-stretch">
    <button
      type="button"
      (click)="onPrint()"
      [disabled]="pdfBusy"
      class="inline-flex items-center justify-center gap-2 min-h-[48px] px-5 py-2.5 rounded-lg text-base font-semibold text-white bg-primary-500 hover:bg-primary-600 disabled:opacity-60 transition-colors flex-1"
    >
      <span class="material-symbols-outlined" aria-hidden="true">print</span>
      <span>הדפס</span>
    </button>

    <button
      type="button"
      (click)="downloadPdf()"
      [disabled]="pdfBusy"
      class="inline-flex items-center justify-center gap-2 min-h-[48px] px-5 py-2.5 rounded-lg text-base font-semibold text-white bg-accent-500 hover:bg-accent-600 disabled:opacity-60 transition-colors flex-1"
      aria-label="הורד את טופס העליות כקובץ PDF"
    >
      <span *ngIf="!pdfBusy" class="material-symbols-outlined" aria-hidden="true">download</span>
      <span *ngIf="pdfBusy" class="material-symbols-outlined animate-spin" aria-hidden="true">progress_activity</span>
      <span>{{ pdfBusy ? 'מכין PDF...' : 'הורד PDF' }}</span>
    </button>

    <!-- WhatsApp share — only visible when the browser truly supports
         sharing a PDF File via the Web Share API (mobile Safari/Chrome).
         Desktop browsers hide the button entirely; use הורד PDF instead. -->
    <button
      *ngIf="canShareFiles"
      type="button"
      (click)="shareViaWhatsApp()"
      [disabled]="pdfBusy"
      class="inline-flex items-center justify-center gap-2 min-h-[48px] px-5 py-2.5 rounded-lg text-base font-semibold text-white bg-[#25D366] hover:bg-[#1ebe5d] disabled:opacity-60 transition-colors flex-1"
      aria-label="שלח את טופס העליות בוואטסאפ"
    >
      <span *ngIf="!pdfBusy" class="material-symbols-outlined" aria-hidden="true">send</span>
      <span *ngIf="pdfBusy" class="material-symbols-outlined animate-spin" aria-hidden="true">progress_activity</span>
      <span>{{ pdfBusy ? 'מכין PDF...' : 'שלח בוואטסאפ' }}</span>
    </button>
  </div>

  <app-logo [width]="'200'" [height]="'200'" [className]="'w-64 h-auto'" [print]="true"></app-logo>

  <ng-container *ngIf="shabbatData; else loading">
    <div class="w-full grid grid-cols-3 place-items-center">
      <div class="flex flex-col items-center space-y-2">
        <label>כניסת שבת</label>
        <p class="text-center font-semibold text-2xl text-green-700">
          {{ shabbatData.shabbatStart | date : "HH:mm" }}
        </p>
      </div>
      <img [src]="candelsIcon" alt="Candles Icon" class="w-12 h-12" />

      <div class="flex flex-col items-center space-y-2">
        <label>צאת שבת</label>
        <p class="text-center font-semibold text-2xl text-red-700">
          {{ shabbatData.shabbatEnd | date : "HH:mm" }}
        </p>
      </div>
    </div>

    <div class="w-full grid grid-cols-1 py-2 gap-2 border-dashed border-b border-black">
      <div class="parashaText h-fit flex flex-col items-center">
        <small class="w-full text-center text-xl">
          {{ shabbatData.hebrew }}
        </small>
        <p class="text-nowrap">פרשת {{ shabbatData.parasha }} </p>
      </div>
    </div>

    <div class="w-full grid grid-cols-3 place-items-center py-2">
      <div class="flex gap-2 items-center flex-col justify-start h-full">
        <label class="stamFont text-xl">חזנים</label>
        <div class="flex gap-1 flex-col items-center">
          <ng-container *ngFor="let name of shabbatData?.hazan">
            <span class="text-lg hazanName">{{name}}</span>
          </ng-container>
        </div>
      </div>
      
      <div class="flex gap-2 items-center flex-col justify-start h-full">
        <label class="stamFont text-xl">פתיחת היכל</label>
        <p class="mx-1 text-lg font-bold text-appBlue">
          {{ ptihatHihal }}
        </p>
      </div>

      <div class="flex gap-2 items-center flex-col justify-start h-full">
        <label class="stamFont text-xl">הפטרה</label>
        <p class="mx-1 text-lg">
          {{ haftara }}
        </p>
      </div>
    </div>

    <div class="w-full book-and-hazan mt-1">
      <div class="w-full grid grid-cols-1 place-items-center align-middle gap-4 bg-gray-200 rounded-lg py-1 border-gray-300">
        <div class="flex flex-col items-center justify-center space-y-2">
          <label><img [src]="bookIcon" alt="Book Icon" class="w-12 h-12"/></label>
          <p class="text-center text-2xl tracking-widest font-bold">
            {{ shabbatData.book }}
          </p>
        </div>
      </div>
    </div>

    <div class="w-full aliyot-table grid grid-cols-2">
      <table class="table table-striped w-fit mt-2 place-self-center">
        <thead>
          <tr class="mx-auto border-b border-gray-200">
            <th class="w-full text-center flex gap-2 justify-center items-center pb-0 text-2xl stamFont" [width]="400">
              עליות
              <img [src]="talitIcon" alt="talit Icon" class="w-8 h-8 mr-2" />
            </th>
          </tr>
        </thead>
       <tbody>
  <ng-container *ngFor="let item of shabbatData.orders">
    <tr class="border-none">
      <td class="text-right justify-start flex gap-2 items-center pb-0 font-bold text-lg">
        <span class="text-lg"> {{ item.name }} - </span>
        <span class="font-normal text-black">
          {{ item.userName }}
        </span>
      </td>
    </tr>
  </ng-container>
</tbody>
      </table>

      <div class="py-4 pb-1 w-full flex flex-col items-end pl-8">
        <table class="table table-striped w-fit mt-6 p-8">
          <thead>
            <tr class="mx-auto border-b border-gray-200">
              <th class="w-full text-center flex gap-2 justify-center items-center p-1 text-nowrap stamFont" [width]="400">
                זמני תפילות
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of shabbatData.prayerTimes" class="p-1 border-none">
              <td class="w-full text-left flex justify-between gap-6 text-nowrap items-center font-bold text-lg p-0">
                <span class="text-lg">{{ item.name }}</span>
                <span class="font-normal text-lg text-black text-center">{{ item.time }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      
        <div class="mt-4 mr-12 text-right">
          <p class="font-semibold underline">אשכבות</p>
          <p class="mb-6 italic text-sm">
            {{ shabbatData.book }} 
          </p>
          <p class="text-red-600 font-bold">שחרית חול: 05:30</p>
          <p class="text-red-600 font-bold">מנחה וערבית: 15 דקות לפני שקיעה</p>
        </div>
      </div>
    </div>

    <div class="w-full p-2 flex flex-col justify-center items-center text-center text-nowrap col-span-2">
      <div class="w-full flex justify-center p-2 mt-8">
        <p class="text-2xl border-y-2 border-appGold py-1">כולם מוזמנים לסעודה שלישית</p>
      </div>
      <small class="text-3xl font-semibold tracking-wider text-green-900 mt-4 font-hebrew" style="font-family: 'Stam Ashkenaz CLM', serif;">
        שבת שלום
      </small>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="w-full h-64 flex justify-center items-center text-center flex-col">
      <p *ngIf="!errorMessage" class="text-2xl font-bold text-blue-800 animate-pulse">מכין טופס עליות לשבת...</p>
      <p class="text-4xl font-bold text-red-800"> {{ errorMessage }}</p>
    </div>
  </ng-template>
</section>